import { Component, OnInit } from '@angular/core';
import { BaseTableService } from 'src/app/services/base-table.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-base-view',
  templateUrl: './base-view.component.html',
  styleUrls: ['./base-view.component.scss']
})
export class BaseViewComponent<T> implements OnInit {

  isLoading = true;
  service: BaseTableService<any>;
  item: T;
  pathUrlList = '';

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) { }

  ngOnInit(): void {
    this.searchFormByParams();
  }

  searchFormByParams() {
    // Buscar ID del tour
    this.route.params.subscribe(params => {
      if (params.id) {
        this.loadItem(params.id);
      } else {
        this.navigator.navigateByUrl('/' + this.pathUrlList);
      }
    });
  }

  loadItem(itemId: number) {
    this.isLoading = true;
    this.service.fetch(itemId).toPromise().then(data => {
      if (!data.success) {
        this.navigator.navigateByUrl('/' + this.pathUrlList);
      }
      this.item = data.response;
      this.isLoading = false;
    });
  }

}